import About from './home/about.png';
import Logo from './default/logo.png';
import HomeImage1 from './home/image1.png';
import HomeImage2 from './home/image2.png';
import HomeShape1 from './home/shape1.png';
import HomeShape2 from './home/shape2.png';
import IlustrasiIndividu from './home/ilustrasi_individu.png';
import IlustrasiKeluarga from './home/ilustrasi_keluarga.png';
import IlustrasiPasangan from './home/ilustrasi_pasangan.png';
import IlustrasiPsikologis from './home/ilustrasi_psikologis.png';
import IlustrasiWorkshop from './home/ilustrasi_workshop.png';
import IlustrasiWebinar from './home/ilustrasi_webinar.png';
import Livia from './home/livia.png';
import LeftArrowInactive from './home/left_inactive.png';
import LeftArrowActive from './home/left_active.png';
import RightArrowInactive from './home/right_inactive.png';
import RightArrowActive from './home/right_active.png';
import DownArrow from './home/down_arrow.png';
import Twitter from './default/twitter.png';
import Instagram from './default/instagram.png';
import Facebook from './default/facebook.png';
import Whatsapp from './default/whatsapp.png';
import Instagram1 from './home/instagram1.jpg';
import Instagram2 from './home/instagram2.jpg';
import Instagram3 from './home/instagram3.jpg';

const Images = {
  About,
  Logo,
  HomeImage1,
  HomeImage2,
  HomeShape1,
  HomeShape2,
  IlustrasiIndividu,
  IlustrasiKeluarga,
  IlustrasiPasangan,
  IlustrasiPsikologis,
  IlustrasiWorkshop,
  IlustrasiWebinar,
  Livia,
  LeftArrowInactive,
  LeftArrowActive,
  RightArrowInactive,
  RightArrowActive,
  DownArrow,
  Twitter,
  Instagram,
  Facebook,
  Whatsapp,
  Instagram1,
  Instagram2,
  Instagram3,
};

export default Images;
